import styled, { css } from 'styled-components';
import { ThemeColours, transparentThemeColour } from '../../../styles/ThemeColours';
import { FONT_STACK, ZIndex } from '../../../styles/constants';

export const PopoverDisplayView = styled.div<{ tooltip: boolean; light: boolean; arrow: boolean }>`
  background-clip: padding-box;
  background-color: ${ThemeColours.mono900};

  border: none;
  ${FONT_STACK}
  border-radius: 4px;
  box-shadow: 0 1px 10px ${transparentThemeColour('mono600', 0.85)};
  color: ${ThemeColours.white};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: normal;
  line-break: auto;
  line-height: 1.42857143;
  margin-top: 8px;
  max-width: 276px;
  padding: 0px;
  position: relative;
  text-align: left;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  white-space: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  z-index: ${ZIndex.TOOLTIP};

  ${props =>
    props.arrow &&
    css`
      bottom: 12px;
    `}

  ${props =>
    props.tooltip &&
    css`
      max-width: unset;
    `}

  ${props =>
    props.light &&
    css`
      background-color: ${ThemeColours.white};
      border: 1px solid ${ThemeColours.mono500};
      color: ${ThemeColours.mono700};
    `}
`;

export const Inner = styled.div<{ tooltip: boolean }>`
  padding: 16px 16px;

  ${props =>
    props.tooltip &&
    css`
      padding: 8px 16px;
    `}
`;

export const Arrow = styled.div`
  background-color: ${ThemeColours.mono900};
  border-radius: 0 0 0 4px;
  bottom: 0;
  height: 24px;
  left: calc(50% - 12px);
  position: absolute;
  transform: rotate(-45deg);
  width: 24px;
  z-index: ${ZIndex.TOOLTIP};
`;
